//venders
import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useParams, useLocation } from "react-router-dom"
import { useTheme } from "@material-ui/core/styles"
import CardHeader from "@material-ui/core/CardHeader"
import AppBar from "@material-ui/core/AppBar"
import Box from "@material-ui/core/Box"
import { withStyles, makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import Typography from "@material-ui/core/Typography"
import Menu from "@material-ui/core/Menu"
import Container from "@material-ui/core/Container"
import Avatar from "@material-ui/core/Avatar"
import Badge from "@material-ui/core/Badge"
import Tooltip from "@material-ui/core/Tooltip"
import MenuItem from "@material-ui/core/MenuItem"
import MultiBaseDropdownList from "../../build/multiBaseDropdownList/MultiBaseDropdownList"
import BellSVG from "../../icons/BellSVG"
import anzyzLegalLogo from "../../../images/tranlogo_h__y_kvalitet_white_.png"
//css
import "./HeaderStyle.css"
import { getNotification, updateNotification } from "../../../actions/headerActions"
import moment from "moment"
import ChangePasswordModel from "./changePassword/ChangePasswordModel"

const useStyles = makeStyles((theme) => ({
	MenuItem: {
		width: "100%",
		padding: "22px",
		border: `solid 1px ${theme.palette.grey.D400}`,
		"&.MuiBox-root": {
			display: "flex",
		},
		"&:focus": {
			"& .MuiListItemIcon-root, & .MuiListItemText-primary": {
				color: theme.palette.common.white,
			},
		},
	},
}))

const StyledMenu = withStyles((theme) => ({
	paper: {
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderBottom: `solid 1px none`,
		"& .MuiList-padding": {
			padding: 0,
		},
	},
}))((props) => (
	<Menu
		elevation={0}
		PaperProps={{
			style: {
				overflowY: "auto",
			},
		}}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: "bottom",
			horizontal: "center",
		}}
		transformOrigin={{
			vertical: "top",
			horizontal: "center",
		}}
		{...props}
	/>
))

const StyledMenuItem = withStyles((theme) => ({
	root: {
		width: "100%",
		padding: "15px",
		border: `solid 1px ${theme.palette.grey.D400}`,

		"& .MuiBox-root": {
			display: "flex",
		},
		"&:focus": {
			"& .MuiListItemIcon-root, & .MuiListItemText-primary": {
				color: theme.palette.common.white,
			},
		},
	},
}))(MenuItem)

const UserProfileView = () => {
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles()
	const dispatch = useDispatch()
	let history = useHistory()
	const location = useLocation()
	const [anchorElUser, setAnchorElUser] = useState(null)
	const multiBaseList = useSelector((state) => state.multiBase.multiBaseList)
	const { user } = useSelector((state) => state?.authtentication?.user)
	const { notification } = useSelector((state) => state?.headerReducers)
	const [openChangePasswordModel, setOpenChangePasswordModel] = useState(false)

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget)
	}

	const handleClose = () => {
		setOpenChangePasswordModel(false)
	}

	const handleCloseUserMenu = (item) => {
		setAnchorElUser(null)
	}

	function stringToColor(string) {
		let hash = 0
		let i
		for (i = 0; i < string.length; i += 1) {
			hash = string.charCodeAt(i) + ((hash << 5) - hash)
		}
		let color = "#"
		for (i = 0; i < 3; i += 1) {
			const value = (hash >> (i * 8)) & 0xff
			color += `00${value.toString(16)}`.slice(-2)
		}
		return color
	}

	var getContrast = function (hexcolor) {
		if (hexcolor.slice(0, 1) === "#") {
			hexcolor = hexcolor.slice(1)
		}
		var r = parseInt(hexcolor.substr(0, 2), 16)
		var g = parseInt(hexcolor.substr(2, 2), 16)
		var b = parseInt(hexcolor.substr(4, 2), 16)
		var yiq = (r * 299 + g * 587 + b * 114) / 1000
		return yiq >= 128 ? theme.palette.text.primary : theme.palette.background.default
	}

	const MenuProps = {
		anchorOrigin: {
			vertical: "bottom",
			horizontal: "left",
			maxWidth: "350px",
		},
		getContentAnchorEl: null,
	}
	const stringAvatar = (name) => {
		return {
			style: {
				...theme?.typography?.avtarText,
				width: "32px",
				height: "32px",
			},
			children: name?.split(" ")[1] ? `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}` : name?.split(" ")[0][0],
		}
	}

	return (
		<div className="notificationSection">
			<Box
				style={{
					ml: "20px",
					display: { md: "flex" },
					cursor: "pointer",
				}}
			>
				<CardHeader
					onClick={handleOpenUserMenu}
					avatar={<Avatar alt={"A"} {...stringAvatar(`${user?.first_name} ${user?.last_name}`)} />}
				/>
				<Box>
					<StyledMenu anchorEl={anchorElUser} keepMounted open={Boolean(anchorElUser)} onClose={handleCloseUserMenu}>
						<StyledMenuItem
							onClick={() => {
								setAnchorElUser(null)
								setOpenChangePasswordModel(true)
							}}
						>
							Change password
						</StyledMenuItem>
					</StyledMenu>
				</Box>
				<ChangePasswordModel open={openChangePasswordModel} onClose={handleClose} />
			</Box>
		</div>
	)
}

export default UserProfileView
